module.exports.version = 'v11.8.2-f7874a42';
